import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import TestimonialsHero from './components/TestimonialsHero';
import TestimonialsCards from './components/TestimonialsCards';
import TestimonialsCategories from './components/TestimonialsCategories';
import TestimonialsStats from './components/TestimonialsStats';
import { useTitle } from '@/hooks/useTitle';
import { SchemaOrg } from '@/components/base/SchemaOrg';

import PageCta from '@/components/feature/PageCta';

const siteUrl = import.meta.env.VITE_SITE_URL;

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  'name': '客戶見證｜保險建築師真實案例與推薦',
  'url': `${siteUrl}/testimonials`,
  'description': '閱讀保險建築師客戶的真實評價與保障規劃案例，了解我們如何協助不同家庭建立穩固的保障結構。',
  'about': {
    '@type': 'ProfessionalService',
    'name': '保險建築師',
    'url': siteUrl,
  },
  'review': [
    {
      '@type': 'Review',
      'reviewRating': { '@type': 'Rating', 'ratingValue': '5', 'bestRating': '5' },
      'author': { '@type': 'Person', 'name': '林媽媽' },
      'reviewBody': '琮恩真的很細心，把我的每一份舊保單都拿出來一一解釋，讓我知道哪些可以留、哪些該調整。感覺像是請了一位建築師來檢查我的保障結構。',
    },
    {
      '@type': 'Review',
      'reviewRating': { '@type': 'Rating', 'ratingValue': '5', 'bestRating': '5' },
      'author': { '@type': 'Person', 'name': '張先生' },
      'reviewBody': '原本以為保險就是買了就放著，經過琮恩的保單健檢才發現有很多重複投保和缺口。現在保障更完整，保費反而更省了。',
    },
    {
      '@type': 'Review',
      'reviewRating': { '@type': 'Rating', 'ratingValue': '5', 'bestRating': '5' },
      'author': { '@type': 'Person', 'name': '陳小姐' },
      'reviewBody': '家裡多了新生兒後一直很焦慮保障夠不夠，琮恩花了很多時間了解我們的家庭狀況和預算，幫我們規劃了一份安心又不會太貴的方案。',
    },
  ],
};

export default function Testimonials() {
  useTitle({
    title: '客戶見證｜保險建築師真實案例與推薦',
    description: '閱讀保險建築師客戶的真實評價與保障規劃案例，了解我們如何協助不同家庭建立穩固的保障結構。',
    canonicalPath: '/testimonials',
  });
  return (
    <main>
      <SchemaOrg data={schemaData} />
      <Navbar />
      <TestimonialsHero />
      <TestimonialsCards />
      <TestimonialsCategories />
      <TestimonialsStats />
      <PageCta />
      <Footer />
    </main>
  );
}